export default __webpack_public_path__ + "static/media/hht2_ep11_timeline_q02_b.2b311df2.png";